import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import DepartmentIdentityContext from "src/contexts/data/DepartmentIdentityContext";
import type { GetDepartmentIdentityByIdResponse } from "src/api/Tmd.dtos";
import useDepartmentIdentityById from "src/hooks/data/load/useDepartmentIdentityById";
import type { SWRConfiguration } from "swr";

interface IDepartmentProviderProps extends PropsWithChildren {
    id?: number;
    configuration?: SWRConfiguration<
        GetDepartmentIdentityByIdResponse,
        GetDepartmentIdentityByIdResponse
    >;
}

const DepartmentIdentityProvider: FC<IDepartmentProviderProps> = ({
    children,
    id,
    configuration,
}) => {
    const context = useDepartmentIdentityById(id, configuration);

    return (
        <DepartmentIdentityContext.Provider value={context}>
            {children}
        </DepartmentIdentityContext.Provider>
    );
};

export const RouteDepartmentIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const { departmentId } = useParams<{ departmentId: string }>();
    const id = departmentId ? parseInt(departmentId, 10) : undefined;

    return <DepartmentIdentityProvider id={id}>{children}</DepartmentIdentityProvider>;
};

export default DepartmentIdentityProvider;
